// MKT-#10: which routes DEFER the aws-amplify cluster (config + token mirror
// + cart widgets) past first paint. Deferring keeps eager Amplify off the
// hero's critical path so public-marketing LCP isn't render-blocked.
//
// DEFAULT-DEFER FOR MARKETING (MKT-#10 follow-up, per Alexis): every registered
// marketing surface defers, so new metro/cluster pages defer AUTOMATICALLY the
// moment they're added to EXACT_MARKETING_PATHS (which they must be anyway, or
// the E-008 dual-nav guard test fails). We do NOT maintain a second per-page
// allowlist that could drift out of sync with the marketing registry.
//
// The ONLY marketing surfaces kept EAGER are the ones that need signed-in state
// at first paint: the price-gated catalog and the auth entry / signup flow.
// Everything that is NOT a marketing surface (dashboard, admin, /account,
// /go/*, /auth/*, /pending-approval, the whole portal) is already eager because
// isMarketingPath() returns false for it.

import { stripEsPrefix } from "@/lib/i18n/es-path";
import { isMarketingPath } from "@/lib/marketing/marketing-paths";

// Marketing surfaces that must stay EAGER even though they render MarketingNav.
// These read signed-in state on the first paint:
//   - /catalog + /catalog/* : wholesale prices are revealed only after sign-in
//   - /sign-in* , /sign-up* : the auth + signup flow itself
function isEagerMarketingException(p: string): boolean {
  if (p === "/catalog" || p.startsWith("/catalog/")) return true;
  if (p === "/sign-in" || p.startsWith("/sign-in/")) return true;
  if (p === "/sign-up" || p.startsWith("/sign-up/")) return true;
  return false;
}

export function shouldDeferAmplify(pathname: string | null | undefined): boolean {
  const p = stripEsPrefix(pathname || "/");
  // Non-marketing routes (portal/dashboard/admin/go/auth) keep Amplify eager.
  if (!isMarketingPath(p)) return false;
  // Marketing routes defer BY DEFAULT, except the auth/cart carve-outs above.
  return !isEagerMarketingException(p);
}
